"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
//
// assets
//
const navLogo_svg_1 = __importDefault(require("../../assets/images/dashboard/navLogo.svg"));
//
// components
//
const Dropdown = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./Dropdown'))));
const Customers = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./Customers'))));
const NavigationSidebar = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./NavigationSidebar'))));
const Orders = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./Orders'))));
const Settings = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./Settings'))));
const Account = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./Account'))));
const Metabase = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./Metabase'))));
const Shipping = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./Shipping'))));
const TrackingPageEditor = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./TrackingPageEditor'))));
const Apps = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./Apps'))));
const LoadingSpinner_1 = __importDefault(require("../general/LoadingSpinner"));
//
// styles
//
const StyledBottomContainer_1 = require("./StyledBottomContainer");
const StyledContainer_1 = require("./StyledContainer");
const StyledContent_1 = require("./StyledContent");
const StyledLogo_1 = require("./StyledLogo");
const StyledLogoContainer_1 = require("./StyledLogoContainer");
const StyledTopBar_1 = require("./StyledTopBar");
const StyledMessageContainer_1 = require("./StyledMessageContainer");
const LaunchDarklyDebug_1 = __importDefault(require("./LaunchDarklyDebug"));
const Dashboard = (props) => {
    const [account, setAccount] = react_1.default.useState('');
    const containerRef = (0, react_1.useRef)(null);
    function handleChangeAccount(newAccount) {
        setAccount(newAccount);
    }
    return (react_1.default.createElement(StyledContainer_1.StyledContainer, { id: 'dashboard-container', ref: containerRef, style: { height: '100vh' } },
        react_1.default.createElement(LaunchDarklyDebug_1.default, null),
        react_1.default.createElement(StyledTopBar_1.StyledTopBar, null,
            react_1.default.createElement(StyledLogoContainer_1.StyledLogoContainer, null,
                react_1.default.createElement(StyledLogo_1.StyledLogo, { alt: 'Malomo', src: navLogo_svg_1.default })),
            react_1.default.createElement(Dropdown, { handleChangeAccount: handleChangeAccount, onLogout: props.onLogout })),
        react_1.default.createElement(StyledBottomContainer_1.StyledBottomContainer, null,
            react_1.default.createElement(NavigationSidebar, null),
            react_1.default.createElement(StyledContent_1.StyledContent, null,
                react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(StyledMessageContainer_1.StyledMessageContainer, null,
                        react_1.default.createElement(LoadingSpinner_1.default, null)) },
                    react_1.default.createElement(react_router_dom_1.Switch, null,
                        react_1.default.createElement(react_router_dom_1.Route, { path: '/orders' },
                            react_1.default.createElement(Orders, null)),
                        react_1.default.createElement(react_router_dom_1.Route, { path: '/customers' },
                            react_1.default.createElement(Customers, null)),
                        react_1.default.createElement(react_router_dom_1.Route, { path: '/settings*' },
                            react_1.default.createElement(Settings, null)),
                        react_1.default.createElement(react_router_dom_1.Route, { path: '/account*' },
                            react_1.default.createElement(Account, { newAccount: account })),
                        react_1.default.createElement(react_router_dom_1.Route, { path: '/reports/metabase' },
                            react_1.default.createElement(Metabase, null)),
                        react_1.default.createElement(react_router_dom_1.Route, { path: '/reports/shipping' },
                            react_1.default.createElement(Shipping, null)),
                        react_1.default.createElement(react_router_dom_1.Route, { path: '/tracking_page_editor*' },
                            react_1.default.createElement(TrackingPageEditor, null)),
                        react_1.default.createElement(react_router_dom_1.Route, { path: '/apps' },
                            react_1.default.createElement(Apps, null)),
                        react_1.default.createElement(react_router_dom_1.Redirect, { to: '/orders' })))))));
};
exports.default = Dashboard;
